import { AutocompleteFieldOption } from '~components/FormFields/v2/Autocomplete/types';
import {
  TaxRateScheduleBasic,
  TaxRateScheduleTypeahead,
} from '~hooks/useTaxRateSchedule/models';

export function toTaxRateScheduleOption(
  taxRateSchedule: TaxRateScheduleTypeahead,
): AutocompleteFieldOption<TaxRateScheduleTypeahead> {
  return {
    _entity: taxRateSchedule,
    label: TaxRateScheduleBasic.formatLabel(taxRateSchedule.name, taxRateSchedule.rate),
    value: taxRateSchedule.id,
  };
}
